import { CellShape } from './types'

export const SHAPES_POINTS: CellShape[] = [
  new Float32Array([0.5, 0.5, 0.5, 0.5, 0.5, 0.5]),
  new Float32Array([1, 0, 1, 1, 0, 1]),
  new Float32Array([0, 0, 1, 1, 0, 1]),
  new Float32Array([0, 0, 1, 0, 1, 1]),
  new Float32Array([0, 0, 1, 0, 0, 1])
]
